export default __webpack_public_path__ + "static/media/Baskerville-Italic.5a24509c.woff2";